document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector('.product-buttons .product-form__buttons button');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => target.click(), 500);
    }
  });
});

(function () {
  function formatDate(dateObj) {
    return dateObj.toLocaleString('en-GB', { month: 'short', day: 'numeric' });
  }

  function updateShippingWidget(cutoffHour, baseDays) {
    const countdown = document.getElementById("countdown");
    const deliveryRange = document.getElementById("delivery-range");

    if (!countdown || !deliveryRange) return;

    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    function updateClock() {
      const now = new Date();
      const timeRemaining = cutoff - now;

      if (timeRemaining <= 0) {
        countdown.innerText = "00h 00m 00s";
        return;
      }

      const hours = String(Math.floor((timeRemaining / (1000 * 60 * 60)) % 24)).padStart(2, '0');
      const minutes = String(Math.floor((timeRemaining / (1000 * 60)) % 60)).padStart(2, '0');
      const seconds = String(Math.floor((timeRemaining / 1000) % 60)).padStart(2, '0');

      countdown.innerText = `${hours}h ${minutes}m ${seconds}s`;

      const startDate = new Date(now);
      startDate.setDate(startDate.getDate() + baseDays);
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 2);

      deliveryRange.innerText = `${formatDate(startDate)} and ${formatDate(endDate)}`;
    }

    updateClock();
    setInterval(updateClock, 1000);
  }

  window.initShippingCountdown = updateShippingWidget;
})();
